<template>
  <path
    d="M19 18.0002L21 19.0002V3.00018C21 1.90018 20.1 1.00018 19 1.00018H8.99C7.89 1.00018 7 1.90018 7 3.00018H17C18.1 3.00018 19 3.90018 19 5.00018V18.0002ZM15 5.00018H5C3.9 5.00018 3 5.90018 3 7.00018V23.0002L10 20.0002L17 23.0002V7.00018C17 5.90018 16.1 5.00018 15 5.00018Z"
  />
</template>
